import Layout from "@components/Layout";
import Anchor from "@components/Util/Anchor";

const Music = ({ title, description, ...props }) => {
  return (
    <>
      <Layout pageTitle={title} description={description}>
        <div className="max-w-screen-xl m-auto p-8">
          <main>
            I make music under the moniker "Pianokely". My first album (made
            while trying to get my newborn daughter to sleep) is called "Sounds
            for Sleep" and is great for concentration and working/studying too.
            I've produced a bunch of other tracks too, so I've included a back
            catalog of those. And I produce, mix, write, and play keyboard/synth
            for the band True North Music. If you'd like to find some music to
            use in your video or other media projects, please see my{" "}
            <Anchor href="/royaltyfreemusic/">
              <span className="text-blue-500 hover:text-blue-600">
                royalty free collection
              </span>
            </Anchor>
            .
            <div className="flex mt-4 mb-4">
              <iframe
                className="rounded-md shadow-lg"
                src="https://open.spotify.com/embed/playlist/6FhEYUBPyQfhZYGxiHpSg6"
                width="100%"
                height="380"
                frameBorder="0"
                allowTransparency={true}
                allow="encrypted-media"
              ></iframe>
              <iframe
                className="ml-4 rounded-md shadow-lg"
                width="100%"
                height="380"
                scrolling="no"
                frameBorder="no"
                allow="autoplay"
                src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/66581604&color=%2313aae3&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"
              ></iframe>
            </div>
            Want to listen on your serivice of choice?{" "}
            <Anchor href="https://solo.to/pianokely">
              <span className="text-blue-500 hover:text-blue-600">
                Find me in more places here
              </span>
            </Anchor>
          </main>
        </div>
      </Layout>
    </>
  );
};

export default Music;

export async function getStaticProps() {
  const configData = await import(`../siteconfig.json`);

  return {
    props: {
      title: `Music | ${configData.default.title}`,
      description: configData.default.description,
    },
  };
}
